/**
 * Comprehensive RemixIcon list for Menu Items
 * Categorized for easy selection
 */

export interface IconOption {
  icon: string;
  label: string;
  category: string;
}

export const MENU_ICONS: IconOption[] = [
  // Dashboard & Home
  { icon: 'ri-dashboard-line', label: 'Dashboard', category: 'Dashboard' },
  { icon: 'ri-home-line', label: 'Home', category: 'Dashboard' },
  { icon: 'ri-home-2-line', label: 'Home 2', category: 'Dashboard' },
  { icon: 'ri-home-3-line', label: 'Home 3', category: 'Dashboard' },
  { icon: 'ri-apps-line', label: 'Apps', category: 'Dashboard' },
  { icon: 'ri-grid-line', label: 'Grid', category: 'Dashboard' },
  { icon: 'ri-layout-line', label: 'Layout', category: 'Dashboard' },

  // Users & Team
  { icon: 'ri-user-line', label: 'User', category: 'Users' },
  { icon: 'ri-user-settings-line', label: 'User Settings', category: 'Users' },
  { icon: 'ri-team-line', label: 'Team', category: 'Users' },
  { icon: 'ri-group-line', label: 'Group', category: 'Users' },
  { icon: 'ri-admin-line', label: 'Admin', category: 'Users' },
  { icon: 'ri-account-circle-line', label: 'Account', category: 'Users' },

  // Settings & Configuration
  { icon: 'ri-settings-line', label: 'Settings', category: 'Settings' },
  { icon: 'ri-settings-2-line', label: 'Settings 2', category: 'Settings' },
  { icon: 'ri-settings-3-line', label: 'Settings 3', category: 'Settings' },
  { icon: 'ri-tools-line', label: 'Tools', category: 'Settings' },
  { icon: 'ri-equalizer-line', label: 'Equalizer', category: 'Settings' },

  // Files & Documents
  { icon: 'ri-file-line', label: 'File', category: 'Files' },
  { icon: 'ri-file-text-line', label: 'Document', category: 'Files' },
  { icon: 'ri-file-list-line', label: 'File List', category: 'Files' },
  { icon: 'ri-folder-line', label: 'Folder', category: 'Files' },
  { icon: 'ri-folder-open-line', label: 'Folder Open', category: 'Files' },
  { icon: 'ri-article-line', label: 'Article', category: 'Files' },

  // Finance & Money
  { icon: 'ri-money-dollar-circle-line', label: 'Dollar', category: 'Finance' },
  { icon: 'ri-money-rupee-circle-line', label: 'Rupee', category: 'Finance' },
  { icon: 'ri-bank-line', label: 'Bank', category: 'Finance' },
  { icon: 'ri-wallet-line', label: 'Wallet', category: 'Finance' },
  { icon: 'ri-exchange-line', label: 'Exchange', category: 'Finance' },
  { icon: 'ri-funds-line', label: 'Funds', category: 'Finance' },
  { icon: 'ri-safe-line', label: 'Safe', category: 'Finance' },

  // Charts & Analytics
  { icon: 'ri-bar-chart-line', label: 'Bar Chart', category: 'Analytics' },
  { icon: 'ri-line-chart-line', label: 'Line Chart', category: 'Analytics' },
  { icon: 'ri-pie-chart-line', label: 'Pie Chart', category: 'Analytics' },
  { icon: 'ri-stock-line', label: 'Stock', category: 'Analytics' },
  { icon: 'ri-donut-chart-line', label: 'Donut Chart', category: 'Analytics' },

  // Buildings & Property
  { icon: 'ri-building-line', label: 'Building', category: 'Property' },
  { icon: 'ri-building-2-line', label: 'Building 2', category: 'Property' },
  { icon: 'ri-community-line', label: 'Community', category: 'Property' },
  { icon: 'ri-government-line', label: 'Government', category: 'Property' },
  { icon: 'ri-store-line', label: 'Store', category: 'Property' },

  // Maps & Location
  { icon: 'ri-map-line', label: 'Map', category: 'Location' },
  { icon: 'ri-map-pin-line', label: 'Map Pin', category: 'Location' },
  { icon: 'ri-route-line', label: 'Route', category: 'Location' },
  { icon: 'ri-road-map-line', label: 'Road Map', category: 'Location' },
  { icon: 'ri-global-line', label: 'Global', category: 'Location' },

  // Communication
  { icon: 'ri-mail-line', label: 'Mail', category: 'Communication' },
  { icon: 'ri-message-line', label: 'Message', category: 'Communication' },
  { icon: 'ri-chat-line', label: 'Chat', category: 'Communication' },
  { icon: 'ri-notification-line', label: 'Notification', category: 'Communication' },
  { icon: 'ri-phone-line', label: 'Phone', category: 'Communication' },

  // Business & Work
  { icon: 'ri-briefcase-line', label: 'Briefcase', category: 'Business' },
  { icon: 'ri-suitcase-line', label: 'Suitcase', category: 'Business' },
  { icon: 'ri-calendar-line', label: 'Calendar', category: 'Business' },
  { icon: 'ri-todo-line', label: 'Todo', category: 'Business' },
  { icon: 'ri-task-line', label: 'Task', category: 'Business' },

  // Reports
  { icon: 'ri-file-chart-line', label: 'Report', category: 'Reports' },
  { icon: 'ri-printer-line', label: 'Print', category: 'Reports' },
  { icon: 'ri-file-pdf-line', label: 'PDF', category: 'Reports' },
  { icon: 'ri-file-excel-line', label: 'Excel', category: 'Reports' },

  // Security
  { icon: 'ri-shield-line', label: 'Shield', category: 'Security' },
  { icon: 'ri-lock-line', label: 'Lock', category: 'Security' },
  { icon: 'ri-key-line', label: 'Key', category: 'Security' },
  { icon: 'ri-shield-check-line', label: 'Shield Check', category: 'Security' },

  // Database & Server
  { icon: 'ri-database-line', label: 'Database', category: 'System' },
  { icon: 'ri-server-line', label: 'Server', category: 'System' },
  { icon: 'ri-hard-drive-line', label: 'Hard Drive', category: 'System' },

  // Utilities
  { icon: 'ri-search-line', label: 'Search', category: 'Utility' },
  { icon: 'ri-filter-line', label: 'Filter', category: 'Utility' },
  { icon: 'ri-refresh-line', label: 'Refresh', category: 'Utility' },
  { icon: 'ri-download-line', label: 'Download', category: 'Utility' },
  { icon: 'ri-upload-line', label: 'Upload', category: 'Utility' },

  // Education
  { icon: 'ri-book-line', label: 'Book', category: 'Education' },
  { icon: 'ri-book-open-line', label: 'Book Open', category: 'Education' },
  { icon: 'ri-graduation-cap-line', label: 'Graduation', category: 'Education' },
  { icon: 'ri-school-line', label: 'School', category: 'Education' },

  // Health
  { icon: 'ri-heart-line', label: 'Heart', category: 'Health' },
  { icon: 'ri-hospital-line', label: 'Hospital', category: 'Health' },
  { icon: 'ri-first-aid-kit-line', label: 'First Aid', category: 'Health' },
  { icon: 'ri-stethoscope-line', label: 'Stethoscope', category: 'Health' },

  // Transport
  { icon: 'ri-car-line', label: 'Car', category: 'Transport' },
  { icon: 'ri-bus-line', label: 'Bus', category: 'Transport' },
  { icon: 'ri-train-line', label: 'Train', category: 'Transport' },
  { icon: 'ri-ship-line', label: 'Ship', category: 'Transport' },

  // Miscellaneous
  { icon: 'ri-star-line', label: 'Star', category: 'Misc' },
  { icon: 'ri-bookmark-line', label: 'Bookmark', category: 'Misc' },
  { icon: 'ri-flag-line', label: 'Flag', category: 'Misc' },
  { icon: 'ri-award-line', label: 'Award', category: 'Misc' },
];

export const ICON_CATEGORIES = [
  'All',
  'Dashboard',
  'Users',
  'Settings',
  'Files',
  'Finance',
  'Analytics',
  'Property',
  'Location',
  'Communication',
  'Business',
  'Reports',
  'Security',
  'System',
  'Utility',
  'Education',
  'Health',
  'Transport',
  'Misc',
];
